import ArticleHero from './article-hero'

export default ArticleHero
